module.exports = __webpack_public_path__ + "assets/img/header_title.b7c9c83e.svg";